import { isNode } from 'detect-node-es';
var isServerSide = isNode;
export var thisIsServer = function () { return isServerSide = true; };
export var isThisServer = function () { return isServerSide; };
